import { useSelector, useDispatch } from 'react-redux';
import { CHeader, CToggler, CHeaderBrand } from '@coreui/react';

const TheHeader = () => {
  const dispatch = useDispatch();
  const sidebarShow = useSelector((state) => state.sidebarShow);
  const user = useSelector((state) => state.cognitoUser);

  const toggleSidebarMobile = () => {
    const val = [false, 'responsive'].includes(sidebarShow) ? true : 'responsive';
    dispatch({ type: 'set', sidebarShow: val });
  };

  return (
    <CHeader className="sed-om-header">
      <CToggler inHeader className="ml-md-3 d-lg-none" onClick={toggleSidebarMobile} />

      <CHeaderBrand className="mx-auto d-lg-none" to="/">
        <div className="sed-om-header-site">
          <p className="title">認証基盤管理システム</p>
        </div>
      </CHeaderBrand>

      <div className="sed-om-header-name px-3 d-lg-none">
        {/* mod@ccs start */}
        {user && user.attributes && user.attributes.email && (
          <p className="name">顧客名 : {user.attributes['email']}</p>
        )}
        {/* mod@ccs end */}
      </div>
    </CHeader>
  );
};

export default TheHeader;
